import React from "react";
import {app} from "app/app";
import {SignUp} from "components/sign-up/SignUp";
import {SignedUpUserAnnouncement} from "buenLib/gtmNotifications/announcements/userAccount/SignedUpUserAnnouncement";
import 'assets/sass/sign-up/SignUp.scss';
import {ParameterErrorResponse} from "buenLib/communication/src/responses/userAcount/signUp/ParameterErrorResponse";
import {UserAlreadyExists} from "buenLib/communication/src/responses/userAcount/signUp/UserAlreadyExists";
import {SignUpSuccessfulResponse} from "buenLib/communication/src/responses/userAcount/signUp/SignUpSuccessfulResponse";
import {VulnerableAccountCredentials} from "buenLib/communication/src/responses/userAcount/VulnerableAccountCredentials";


class SignUpController extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                email: {},
                password: {},
            },
            confirmationEmailSent: false,
            mobileFormIsVisible: false,
            operationInProcess: false
        };
        this.setFieldErrors = this.setFieldErrors.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.signUp = this.signUp.bind(this);
        this.renderMobileForm = this.renderMobileForm.bind(this);
        this.goToLogin = this.goToLogin.bind(this);
    }

    setFieldErrors(fieldErrors, generalErrors) {
        let formData = this.state.formData;
        Object.keys(fieldErrors).forEach(fieldName => {
            formData[fieldName].error = fieldErrors[fieldName];
        });
        this.setGeneralErrors(formData, generalErrors);
        this.setState({formData: formData});
    }

    setGeneralErrors(formData, generalErrors) {
        const errorTypes = Object.keys(generalErrors);
        if (errorTypes.length > 0) {
            let errorMessage = "";
            errorTypes.forEach(errorType => {
                errorMessage += generalErrors[errorType];
            });
            formData['email'].error = errorMessage;
        }
    }

    handleChange(event) {
        let inputName = event.target.name;
        let value = event.target.value;
        let formData = this.state.formData;
        formData[inputName].value = value;
        formData[inputName].error = '';
        this.setState({formData: formData});
    }

    signUp(recaptcha = null) {
        this.setState({operationInProcess: true});
        const formData = this.state.formData;
        app.apiClient().signUp(recaptcha, formData.email.value, formData.password.value, response => {
                this.setState({operationInProcess: false});
                if (response instanceof SignUpSuccessfulResponse) {
                    this.setState({confirmationEmailSent: true});
                    const userJson = response.content();
                    app.announcer().announce(new SignedUpUserAnnouncement(userJson.email, userJson.id))
                } else if (response instanceof ParameterErrorResponse) {
                    this.setFieldErrors(response.fieldErrors(), response.generalErrors());
                } else if (response instanceof VulnerableAccountCredentials) {
                    this.setFieldErrors({}, {
                        error: 'Esta combinación de usuario y contraseña es insegura.',
                    });
                } else if (response instanceof UserAlreadyExists) {
                    this.setFieldErrors({}, {
                        error: 'El email ingresado ya existe en la plataforma.',
                    });
                } else {
                    this.setFieldErrors({}, {
                        error: 'Hubo un error inesperado, por favor intentá nuevamente.',
                    });
                }
            },
        );
    }

    renderMobileForm() {
        this.setState({mobileFormIsVisible: true});
    }

    goToLogin() {
        this.props.history.push(app.routes().index);
    }

    render() {
        return <SignUp renderMobileForm={this.renderMobileForm}
                       isMobile={this.state.mobileFormIsVisible}
                       formData={this.state.formData}
                       handleInputChange={this.handleChange}
                       handleSignUp={this.signUp}
                       goToLogin={this.goToLogin}
                       operationInProcess={this.state.operationInProcess}
                       verificationEmailSent={this.state.confirmationEmailSent}/>;
    }
}

export default SignUpController;
